const getHeader = () => document.querySelector('#header-component');

const updateAccountPopoverOffset = () => {
  const header = getHeader();
  if (!(header instanceof HTMLElement)) return;

  const headerBottom = Math.round(header.getBoundingClientRect().bottom);
  const offsetTop = Math.max(headerBottom - 1, 0);
  header.style.setProperty('--account-offset-top', `${offsetTop}px`);
};

/**
 * @param {EventTarget | null} target
 */
const isAccountInteraction = (target) =>
  target instanceof Element && Boolean(target.closest('#header-component shopify-account'));

document.addEventListener(
  'pointerdown',
  (event) => {
    if (!isAccountInteraction(event.target)) return;
    updateAccountPopoverOffset();
  },
  { capture: true, passive: true }
);

document.addEventListener(
  'focusin',
  (event) => {
    if (!isAccountInteraction(event.target)) return;
    updateAccountPopoverOffset();
  },
  true
);

window.addEventListener('resize', updateAccountPopoverOffset, { passive: true });

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', updateAccountPopoverOffset, { once: true });
} else {
  updateAccountPopoverOffset();
}
